// Auto-generated translation for cs.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:18:31.237348+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Pro majitele koní",
    title: "Vše pro vašeho koně. V jedné aplikaci.",
    subtitle: "Spravujte zdraví, trénink, plánování a odborníky z jednoho přehledného profilu.",
    primaryCTA: {
      label: "Začít zdarma",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobrazit Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Profil koně — váha, vakcinace, EquiCoach, výživa a trénink na jedné obrazovce",
      caption: "Váš kůň, kompletně přehledně.",
    },
    problem: "Termíny, fotografie, trénink, výživa a zdravotní záznamy pravděpodobně uchováváte roztříštěně — ve skupinách WhatsApp, krabicích od bot a různých aplikacích. To vede ke ztrátě přehledu.",
    solution: "EquiSight vytvoří z vašeho koně jeden kompletní digitální profil, který máte vždy po ruce.",
    benefits: [
      "Jeden kompletní profil pro každého koně",
      "Zdraví, podkovář, zubař a fyzioterapeut na jednom místě",
      "Kalendář s chytrými připomínkami",
      "Fotografie, poznámky a historie bez omezení",
      "Záloha všech dat u Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 kůň · vždy zdarma",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Více koní + záloha",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Připraveni začít?",
      title: "Začněte dnes se svým prvním koněm.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Více koní. Větší přehled. Větší jistota.",
    subtitle: "Upgradujte na Premium a spravujte všechny své koně bez omezení — s plnou inteligencí EquiCoach.",
    primaryCTA: {
      label: "Začněte 14 dní zdarma",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Všechny ceny",
      href: "/#pricing",
    },
    audience: "Pro majitele, sportovní jezdce a chovatele koní s více koňmi.",
    features: [
      "Přidávejte neomezený počet koní",
      "Kompletní historie každého koně",
      "Záloha dat",
      "Rozšířené přehledy EquiCoach",
      "Chytrá upozornění a plánování",
      "Zdraví a trénink plně propojeny",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Méně než €0,17 za den",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Připraveni?",
      title: "Upgradujte na Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Pro jezdce z jezdeckých škol",
    title: "Zlepšujte se, i bez vlastního koně.",
    subtitle: "Sledujte své lekce, tréninky a pokrok v EquiSight — za méně, než stojí šálek kávy měsíčně pro tátu nebo mámu. Nebo dobré zmrzlinové pohárky se šlehačkou.",
    primaryCTA: {
      label: "Začít s Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Jak to funguje?",
      href: "#features",
    },
    problem: "Jako jezdec z jezdecké školy často nemáte vlastního koně, ale přesto chcete růst a mít přehled o svých lekcích, cílech a koních, na kterých jedete.",
    solution: "Funkce pro jezdecké školy jsou standardně součástí Premium — sledujte svůj vlastní rozvoj a prohlížejte připojené školní koně v režimu jen pro čtení.",
    features: [
      "Zaznamenávat tréninky",
      "Stanovovat cíle",
      "Sledovat pokrok",
      "Zobrazovat školní koně se jménem a fotografií",
      "Bez přístupu k soukromým zdravotním datům",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Za měsíc · funkce jezdecké školy v ceně",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Staňte se členem",
      title: "Začněte jako jezdec z jezdecké školy.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Pro jízdárny a stáje",
    title: "Zpřístupněte svou jízdárnu digitálně každému jezdci.",
    subtitle: "Dejte jezdcům propojení s koňmi, lekcemi a pokrokem — bez sdílení citlivých dat stáje.",
    primaryCTA: {
      label: "Požádat o přístup",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobrazit moduly",
      href: "#features",
    },
    audience: "EquiSight pomáhá jízdárnám a stájím udržet jezdce déle zapojené a odlišit se v digitálním světě.",
    features: [
      "Zpřístupnění koní jízdárny jezdcům",
      "Jméno a fotografie každého koně",
      "Propojení jezdců s koňmi",
      "Přístup pouze pro čtení u citlivých dat",
      "Centralizovaná historie lekcí a tréninků",
      "Správa uživatelů s rolemi",
    ],
    benefits: [
      "Silnější vazba s jezdci",
      "Profesionálnější vystupování",
      "Dodatečná digitální služba pro členy",
      "Nový zdroj příjmů prostřednictvím používání aplikace",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Za měsíc · funkce jízdárny pro jezdce v ceně",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Připraveni?",
      title: "Aktivujte Modul Jízdárny.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Modul chovu",
    title: "Přehled nad cyklem, březostí a vývojem hříběte.",
    subtitle: "Kompletní modul chovu pro majitele klisen a chovatele — od krytí po hříbě, v jediné časové ose.",
    primaryCTA: {
      label: "Aktivovat modul chovu",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobrazit funkce",
      href: "#features",
    },
    audience: "Pro chovatele, majitele klisen a stáje spravující více klisen.",
    features: [
      "Sledování cyklu",
      "Zaznamenávání říje",
      "Evidování dat inseminace",
      "Odpočítávání do ultrazvuků",
      "Plánování kontrol březosti",
      "Rodokmen a původ",
      "Vývoj hříběte",
      "Přehled všech březích klisen",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Měsíčně · Modul chovu zahrnut v Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Začněte dnes",
      title: "Začněte se správou chovu.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Modul pro kováře",
    title: "Pracujte chytřeji jako kovář. Zaznamenávejte vše profesionálně.",
    subtitle: "Diář, fotografie, poznámky a historie ošetření v jednom modulu — méně nedorozumění, silnější dokumentace.",
    primaryCTA: {
      label: "Začít jako kovář",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobrazit Professional Balíček",
      href: "/professional",
    },
    audience: "Pro kováře, kteří chtějí zlepšit přehled, dokumentaci a komunikaci s klienty.",
    features: [
      "Vlastní diář",
      "Schůzky podle klienta",
      "Zobrazení profilů koní",
      "Přidání fotografií před a po",
      "Zaznamenání ošetření",
      "Uložení rad a poznámek",
      "Oznámení ETA klientovi: \"Kovář je na cestě\"",
    ],
    benefits: [
      "Profesionálnější práce",
      "Méně nedorozumění",
      "Lepší vedení dokumentace",
      "Silnější pozice při odpovědnosti",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Za měsíc · Modul pro kováře zahrnut v Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Připraveni?",
      title: "Aktivujte Modul pro kováře.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Modul zubní péče",
    title: "Kompletní zubní dokumentace pro každého koně.",
    subtitle: "Zaznamenávejte nálezy, ošetření a následnou péči přímo v EquiSight.",
    primaryCTA: {
      label: "Začít jako koňský zubař",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobrazit Professional Bundle",
      href: "/professional",
    },
    audience: "Koňští zubaři, veterináři a praxe, které chtějí pracovat strukturovaně.",
    features: [
      "Zaznamenání zubní prohlídky",
      "Nálezy podle ošetření",
      "Přidání fotografií",
      "Zpráva pro majitele",
      "Doporučení pro následnou péči",
      "Historie pro každého koně",
      "Plánování nové schůzky",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Za měsíc · Modul zubní péče zahrnut v Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Připraveni?",
      title: "Aktivujte modul zubní péče.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fyzio / Osteo modul",
    title: "Sledujte tělo, pohyb a regeneraci profesionálně.",
    subtitle: "Pro fyzioterapeuty a osteopaty, kteří chtějí koně systematicky doprovázet.",
    primaryCTA: {
      label: "Začít jako fyzio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobrazit Professional Bundle",
      href: "/professional",
    },
    features: [
      "Příjem na koně",
      "Zaznamenávání tělesných nálezů",
      "Přidávání fotek a videí",
      "Vytvoření zprávy o léčbě",
      "Sdílení cvičení a následné péče",
      "Sledování průběhu regenerace",
      "Historie na koně",
    ],
    benefits: [
      "Lepší přehled v čase",
      "Profesionální reporting",
      "Jasná komunikace s majitelem, trenérem a jezdcem",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Za měsíc · Fyzio / Osteo modul zahrnut v Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Připraveni?",
      title: "Aktivujte Fyzio / Osteo modul.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Trenérský modul",
    title: "Koučujte jezdce pomocí dat, cílů a pokroku.",
    subtitle: "Udělejte trénink měřitelným a vedení profesionálnějším — pro jednoho nebo více jezdců.",
    primaryCTA: {
      label: "Začít jako trenér",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobrazit Pro balíček",
      href: "/#pricing",
    },
    audience: "Pro instruktory, trenéry a kouče s více jezdci nebo koňmi.",
    features: [
      "Propojit jezdce",
      "Sledovat koně",
      "Nastavit tréninkové cíle",
      "Poskytovat zpětnou vazbu",
      "Analyzovat výsledky ze závodů",
      "Zobrazit postup každé kombinace",
      "Používat analýzy protokolů pro zaměření tréninku",
    ],
    benefits: [
      "Lepší vedení",
      "Více struktury",
      "Profesionálnější komunikace",
      "Silnější vztah s klienty",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Za měsíc · Trenérský modul zahrnut v Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Připraveni?",
      title: "Aktivujte Trenérský modul.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Analýza závodů",
    title: "Od protokolu k lepšímu výkonu.",
    subtitle: "Nahrajte svůj závodní protokol a zjistěte, kde ztrácíte body — nejen sledujte své skóre, ale pochopte, jak se zlepšit.",
    primaryCTA: {
      label: "Analyzujte svůj první protokol",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobrazit Premium",
      href: "/premium",
    },
    features: [
      "Nahrání fotografie protokolu",
      "Zpracování přední a zadní strany",
      "Rozpoznání třídy, čísla jízdy a rozhodčího",
      "Analýza skóre podle jednotlivých prvků",
      "Shrnutí komentářů",
      "Zobrazení silných a slabých stránek",
      "Trendy pro kombinaci kůň–jezdec",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Za měsíc · analýza závodů zahrnuta od tarifu Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Připraveni?",
      title: "Začněte s analýzou závodů.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional balíček",
    title: "Pro profesionály v oblasti koní.",
    subtitle: "Podkovář, zubař, fyzioterapeut, osteopat nebo trenér: spolupracujte v jednom digitálním koňském spisu.",
    primaryCTA: {
      label: "Začít jako profesionál",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobrazit jednotlivé moduly",
      href: "#features",
    },
    audience: "Professional balíček kombinuje všechny odborné moduly v jednom předplatném.",
    features: [
      "Modul podkovář",
      "Modul zubař",
      "Modul fyzio / osteo",
      "Kalendář a správa klientů",
      "Profily koní a reporty",
      "Historie léčby a vedení spisu",
      "Komunikace s majitelem",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Za měsíc · všechny odborné moduly v ceně",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Připraveni?",
      title: "Zvolte Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Tísňová čísla koně",
    title: "Vždy správná pomoc na dosah ruky.",
    subtitle: "V nouzové situaci záleží na každé sekundě. S EquiSight máte všechny důležité kontaktní údaje svého koně okamžitě po ruce — jedno klepnutí a voláte.",
    primaryCTA: {
      label: "Připravte si tísňové kontakty",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Začněte zdarma s EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Tísňové kontakty — okamžité volání, zprávy přes WhatsApp nebo navigace k veterináři, klinice a kovaři",
      caption: "Jedno klepnutí. Žádná panika.",
      embeddedFrame: true,
    },
    problem: "Váš kůň má problém — kolika, zranění, panika. A pak začíná hledání. Komu zavoláte? Máte správné číslo? Je to pohotovostní číslo? Drahocenný čas se ztrácí.",
    solution: "S EquiSight máte vše okamžitě po ruce. Žádné hledání. Žádné pochybnosti. Jedno klepnutí a jste v kontaktu.",
    scenario: {
      title: "Představte si — váš kůň vykazuje příznaky koliky.",
      steps: [
        "Otevřete EquiSight",
        "Klepnete na \"Veterinář\"",
        "Okamžitě voláte",
      ],
      tagline: "Žádný stres. Žádné hledání. Jen akce.",
    },
    features: [
      "Všechna tísňová čísla na jednom místě",
      "Volání jedním klepnutím přímo z aplikace",
      "WhatsApp jedním klepnutím",
      "Okamžitá navigace na adresu",
      "Vlastní seznam kontaktů pro každého koně",
      "Veterinář, klinika, kovář, zubař, fyzioterapeut",
      "Adresa a popis trasy okamžitě k dispozici",
      "Označte oblíbená čísla hvězdičkou",
      "Tísňová čísla (112, 144) vždy nahoře",
    ],
    benefits: [
      "Klid a kontrola v nouzové situaci",
      "Všichni ve stáji mají stejná čísla po ruce",
      "Žádné zapomenuté vizitky",
      "Reagujte o sekundy rychleji při naléhavých situacích",
    ],
    audience: "Pro majitele koní, ošetřovatele, trenéry a stáje — pro každého, kdo je zodpovědný za koně.",
    showcase: {
      eyebrow: "Předem připraveno pro vás",
      title: "13 kategorií kontaktů — připraveno k vyplnění.",
      description: "Od veterináře a pohotovostní kliniky po sedláře, instruktora a správce pastvin. EquiSight zná váš svět a předem připraví správná kontaktní pole. Klepněte, vyplňte, hotovo.",
      bullets: [
        "Pohotovost a zdraví — veterinář, pohotovost, klinika, linka otrav",
        "Každodenní péče — kovář, zubař, fyzioterapeut, instruktor",
        "Stáj a pastvina — správce stáje, správce pastvin, pensionát",
        "Krmivo a vybavení — dodavatelé sena, jadrného krmiva a slámy",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Obrazovka správy tísňových kontaktů — všechny navrhované kontakty podle kategorie",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Kontrolní seznam tísňových čísel koně",
      items: [
        "Veterinář",
        "Pohotovostní klinika (24/7)",
        "Záchranná služba pro zvířata · 144",
        "Kovář",
        "Záložní kontaktní osoba",
        "Obecné tísňové číslo · 112",
      ],
      cta: {
        label: "Otevřít v EquiSight a okamžitě vyplnit",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Tísňová čísla",
          price: "Gratis",
          note: "Vždy zdarma · pro každého, v každém předplatném",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ujistěte se, že jste připraveni",
      title: "Dříve, než to bude potřeba.",
      href: "/#waitlist",
    },
    microcopy: [
      "Žádné závazky",
      "Nastaveno do 2 minut",
      "Kdykoli upravitelné",
    ],
  },
};

export default LANDINGS;
